import React from 'react';

import PropTypes from 'prop-types';

import { useDispatch } from 'react-redux';
import { t } from 'i18next';

import { Button, Col, Divider, Modal, Row } from 'antd';
import { exportPortfolio } from '../../data/store/portfolio/portfolioActions';

const ModalExportPortfolio = ({open, name, portfolio_code, close} ) => {
  const dispatch = useDispatch();

  const onExport = () => {
    dispatch(exportPortfolio({id: open, close}));
  };

  return (
    <Modal
      width={700}
      className="modal-content-paper"
      open={open}
      onCancel={close}
      footer={null}
      zIndex={1600}
      destroyOnClose
    >
      <Row justify="start">
        <Col className="modal-title">{t('EXPORT_PORTFOLIO')}</Col>
      </Row>
      <Divider className="modal-divider" />
      <Row justify="start" className="modal-text-wrapper">
        <Col>
          <p className="modal-description">{t('EXPORT_PORTFOLIO_PROMT')}</p>
          <p className="modal-name" style={{ fontWeight: '600' }}>
            {name} {` (code: ${portfolio_code})`}{' '}
          </p>
        </Col>
      </Row>
      <Row justify="end" style={{marginTop: '50px'}}>
      <Col>
        <Button
          className="modal-action-btn cancel-btn"
          onClick={close}
        >
          {t('CANCEL')}
        </Button>
        <Button className="modal-action-btn save-btn" onClick={onExport}>
          {t('EXPORT')}
        </Button>
      </Col>
      </Row>
    </Modal>
  );
};

export default ModalExportPortfolio;

ModalExportPortfolio.propTypes ={
  open: PropTypes.string,
  name: PropTypes.string,
  portfolio_code: PropTypes.number,
  close: PropTypes.func,
};